// extracted by mini-css-extract-plugin
export var displayNone = "_kc-6";
export var imgContainer = "_kc-2";
export var overflowHidden = "_kc-3";
export var productInfoCardButtonContainer = "_kc-5";
export var productTitleText = "_kc-4";
export var rightArrow = "_kc-1";
export var rightArrowContainer = "_kc-0";